module.exports = __webpack_public_path__ + "img/worm_cylinder_left.prt.9cbb3389.jpg";